<template>
    <Form
        submitButtonName="Create Signal"
        :onSubmit="onSubmit"
        :recordProps="record"
    />
</template>

<script>
import Form from "./Form.vue";
import SignalService from "@/services/signal.service.js";
import { ref } from 'vue';
import { toast } from 'vue3-toastify';

const toastId = ref('');

export default {
    name: "BroadcastSignalNew",
    components: {
        Form
    },
    data() {
        return {
            record: {
                name: '',
                details: '',
                send_now: true,
                send_minutes: '',
                status: true,
                selected_package: [],
                send_notif_via: []
            },
        };
    },
    methods: {
        showLoading(){
            toastId.value = toast.loading('Please wait...');
        },
        showSuccess(){
            toast.update(toastId.value, {
                render: "Create Successfully",
                closeOnClick: true,
                closeButton: true,
                type: 'success',
                isLoading: false,
                autoClose: 3000
            });
            
            setTimeout(() => {
                this.$router.replace('/broadcast-signal')
            }, 1000);     
        },
        showFailed(e){
            toast.update(toastId.value, {
                render: e,
                closeOnClick: true,
                closeButton: true,
                type: 'error',
                isLoading: false,
                autoClose: 3000
            });
        },
        onSubmit(data){
            this.showLoading()
            
            SignalService.create(data).then(e => {
                console.log(e)
                this.showSuccess()
            }).catch(e => {
                this.showFailed(e.response.data.code_message)           
            });
        }
    }
}
</script>